import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'download-upload',
  templateUrl: './download-upload.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryDownloadUploadComponent implements OnInit {
  @Input() data;
  @Output() moveNextPreviousEvent = new EventEmitter<any>();

  innerContent = {
    title: 'Here’s the <span class="font-bold text-[#25508E]"> list of items </span> to add from your mobile device ',
    cardSubtitle: 'Selected items to add PDF',
    downloadType: 'upload',
  };

  ngOnInit(): void {}

  previousNextDownloadEvent(event) {
    this.moveNextPreviousEvent.emit({ status: event?.status, ...(event.status == 'forward' && { id: this.data?.id }) });
  }
}
